import { USER_DETAIL_ACTIONS } from 'Actions/index';

const initialState = {
  name: '',
  designation: '',
  email: '',
  access: 'HR Partner',
  status: 'Active',
  createdAt: '',
  employeesCount: 0,
};

const { SET_USER_INFO } = USER_DETAIL_ACTIONS;

const userViews = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_INFO:
      return {
        ...state,
        ...action.payload,
        status: action.payload.isActive ? 'ACTIVE' : 'INACTIVE',
      };
    default:
      return state;
  }
};

export default userViews;
